import React, { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { accountingApi } from "@/lib/apiClient";

const fmt = (c) => (c.field === "amount" ? `amount ${Number(c.was).toLocaleString(undefined, { minimumFractionDigits: 2 })} → ${Number(c.now).toLocaleString(undefined, { minimumFractionDigits: 2 })}` : `${c.field} ${c.was} → ${c.now}`);

export const XeroDriftCard = ({ inv, user, onChanged, provider = "xero", label = "Xero" }) => {
  const [busy, setBusy] = useState(false);
  const d = inv[`${provider}_drift`];
  if (!d) return null;
  const ack = () => {
    setBusy(true);
    accountingApi(provider).ackDrift(inv.id, user).then((u) => { onChanged(u); toast.success(`${label} change acknowledged`); }).catch((e) => toast.error(e?.response?.data?.detail || "Could not acknowledge")).finally(() => setBusy(false));
  };
  if (d.acknowledged) {
    return <p className="mb-3 text-xs text-muted-foreground flex items-center gap-1.5" data-testid={`${provider}-drift-acked`}><Check className="h-3 w-3 text-emerald-500" /> {label} change acknowledged by {d.acknowledged.by} · {new Date(d.acknowledged.at).toLocaleString()}</p>;
  }
  return (
    <div className="mb-3 rounded-lg border border-amber-500/40 bg-amber-500/10 p-3" data-testid={`${provider}-drift-card`}>
      <div className="flex items-center gap-2 text-sm font-medium text-amber-500"><AlertTriangle className="h-4 w-4" /> Changed in {label} after approval</div>
      <ul className="mt-1.5 space-y-0.5 text-xs" data-testid={`${provider}-drift-items`}>{d.items.map((c, i) => <li key={`${c.field}-${i}`} className="font-mono">{fmt(c)}</li>)}</ul>
      <p className="mt-1.5 text-[11px] text-muted-foreground">Detected {new Date(d.detected_at).toLocaleString()}. Re-sync to {label} to restore the approved figures, or acknowledge to accept the bill as it is in {label}.</p>
      <Button size="sm" variant="outline" className="mt-2 h-7 text-xs" onClick={ack} disabled={busy} data-testid={`${provider}-drift-ack-btn`}>{busy ? <Loader2 className="h-3 w-3 mr-1 animate-spin" /> : <Check className="h-3 w-3 mr-1" />} Acknowledge change</Button>
    </div>
  );
};
